import { ReportBuilderName } from 'dashboard/models/report-template';

export const BUILDER_LABELS: Record<
  ReportBuilderName,
  { title: string; description: string; helpCenterLink: string }
> = {
  [ReportBuilderName.AddressLookup]: {
    title: 'Address Lookup',
    description:
      'The report returns detailed metadata for a given address and includes two map views. This is currently for US only.',
    helpCenterLink: 'https://help.withpersona.com/articles/79VIhKIprbykNbIDkzkAHt/',
  },
  [ReportBuilderName.AdverseMedia]: {
    title: 'Adverse Media',
    description:
      'The report screens an individual across a global database of 300+ million news articles to surface any negative or unfavorable information associated with an individual.',
    helpCenterLink: 'https://help.withpersona.com/articles/7K0LSbrfPvUsuBHGCjUhsr/',
  },
  [ReportBuilderName.BusinessAdverseMedia]: {
    title: 'Business Adverse Media',
    description:
      'The report screens a business across a global database of 300+ million news articles to surface any negative or unfavorable information associated with a business.',
    helpCenterLink: 'https://help.withpersona.com/articles/7wGfEzTPrmtHdt9FzZbS1m/',
  },
  [ReportBuilderName.BusinessWatchlist]: {
    title: 'Business Watchlist',
    description: 'The report screens a business across 100+ global sanction and warning lists.',
    helpCenterLink: 'https://help.withpersona.com/articles/4y3oaeL7pc2f5DHKT50smE/',
  },
  [ReportBuilderName.CryptoAddressWatchlist]: {
    title: 'Crypto Address Watchlist',
    description: 'The report flags any wallet addresses that might be sanctioned.',
    helpCenterLink: 'https://help.withpersona.com/articles/562IPh6XJ91ekE3kAEOrLj/',
  },
  [ReportBuilderName.EmailAddress]: {
    title: 'Email Risk',
    description:
      'The report assesses the fraud risk of an email address and confirms its authenticity.',
    helpCenterLink: 'https://help.withpersona.com/articles/4IqHs9oWE6ihGakWUzYCcL/',
  },
  [ReportBuilderName.PhoneNumber]: {
    title: 'Phone Risk',
    description:
      'The report assesses the fraud risk of a phone number and confirms its authenticity.',
    helpCenterLink: 'https://help.withpersona.com/articles/6MsSJ5GQjHhtIN0xxLLeby/',
  },
  [ReportBuilderName.PoliticallyExposedPerson]: {
    title: 'Politically Exposed Person',
    description:
      'The report screens an individual to determine if the individual is or has been entrusted with a prominent function by a local, regional, national or international governmental body.',
    helpCenterLink: 'https://help.withpersona.com/articles/116MoqsoZ0B5FYkdR8Hufp/',
  },
  [ReportBuilderName.Watchlist]: {
    title: 'Watchlist',
    description: 'The report screens an individual across 100+ global sanction and warning lists.',
    helpCenterLink: 'https://help.withpersona.com/articles/UQGaDEhkQ7TLAMJsjuXiX/',
  },
};
